import FileService from './../_services/index.js'
import utilsLocal from "@/utils/filesDropBox";
import {
  processNameFile,
  nameIsEquals,
  montaItemArquivoPreview,
  ajustaArquivosPreview,
  genIdTemp,
  manyFilesSending,
  manyFilesDeleting,
  sleep
} from "./utils"

const state = {
  loading: false,
  files: [],
  erros: '',
}

const mutations = {
  SET_FILES : (state, { files, chave_id, value, origin }) => {
    let filesPreview = JSON.parse(JSON.stringify(ajustaArquivosPreview(files, chave_id, value, origin)))
    let arrDel = []
    state.files.forEach((el, index) => {if (!el.isUploading && !el.isPromisseSend) arrDel.push(index)})
    arrDel.sort((a,b) => a < b ? 1 : a > b ? -1 :0)
    arrDel.forEach(i => state.files.splice(i, 1))
    filesPreview.forEach(el => state.files.push(el))
  },
  SET_FILE_ARRAY : (state, {file}) => {
    state.files.push(file)
  },
  SET_SUBST_FILE : (state, { file, hash }) => {
    let index = null
    state.files.forEach((el, idx) => {if (el.hash == hash) index = idx})
    if (index !== null) state.files.splice(index, 1)
    state.files.push(file)
  },
  REPLACE_FILE: (state, {file, index}) => {
    state.files[index] = Object.assign({}, file)
  },
  DELETE_FILE_ARRAY : (state, hash) => {
    let index = null
    state.files.forEach((el, idx) => { if (el.hash == hash) index = idx })
    if (index !== null) state.files.splice(index, 1)
  },
  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },
  ERASE_ERROS : (state) => {
    state.erros = ''
  },
}


const actions = {
  GET_FILES : async ({ commit }, {url, chave_id, value, origin}) => {
    commit('SET_FILES', { files : [], chave_id, value, origin})
    commit('ERASE_ERROS')
    return new Promise(async (resolve, reject) => {
      await FileService.getFiles(url, value)
      .then(response => {
        if (response.data.status) {
          commit('SET_FILES', { files : response.data.files ? response.data.files : [], chave_id, value, origin })
          resolve(response.data)
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
          reject(response.data.erro)
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: "Erro ao acessar API" })
        reject(error)
      })
    })
  },

  SEND_FILE: async ({commit, state}, {file, index, url, chave_id, value, origin}) => {
    commit('ERASE_ERROS')
    return new Promise(async (resolve, reject) => {

      file.loading = true
      file.isPromisseSend = true
      file.name = `${file.nome}.${file.ext}`
      let hash = file.hash

      let esperar = false
      for (let i = 0; i < 5000; i++) {
        let tst_files = state.files
        esperar = manyFilesSending(tst_files)
        if (!esperar) break
        await sleep(5000)
      }

      file.isUploading = true

      //gera url to upload
      let urlDB = null
      try {
        urlDB = await utilsLocal.geraUrlDropBox(file, url, value, false)
      } catch (error) {
        reject(error)
      }

      if (!urlDB) reject('Erro ao gerar link URL Upload')

      //upload para dropbox
      let fileUploaded = null
      try {
        fileUploaded = await utilsLocal.uploadFileToUrlDropBox(file, urlDB.urlupload)
      } catch (error) {
        reject(error)
      }

      if (!fileUploaded) reject(`Erro fazer Upload do arquivo ${file.nome}`)

      //get file enviado para bucket (dropbox)
      let fileStoredBucket = null
      if (fileUploaded.data && fileUploaded.data['content-hash']) {
          try {
            let url_file = `${url}/file?id=${value}&hash=${fileUploaded.data['content-hash']}`
            fileStoredBucket = await utilsLocal.getFileUploadedBucket(url_file)
            let respFile = fileStoredBucket && fileStoredBucket.data ? montaItemArquivoPreview(fileStoredBucket.data.file, chave_id, value, origin) : null
            if (respFile) {
              commit('SET_SUBST_FILE', {file: respFile, hash})
            }
          } catch (error) {
            reject(error)
          }
      }

      resolve(fileUploaded)

    })
  },


  UPDATE_FILE: ({commit}, {file, url, chave_id, value, origin}) => {
    return new Promise(async (resolve, reject) => {

      let {nameNew, nameOld, nameBkp} = processNameFile(file)

      if (nameIsEquals(nameNew, nameOld)) {
        resolve()
        return
      }

      if (!file.id) {
        file.name = nameNew
        resolve()
        return
      }

      file.textLoading = "Alterando nome arquivo..."
      file.loading = true

      await FileService.updateFile(url, { fileold: nameOld, filenew: nameNew })
      .then(response => {
        if (response.data.status) {
          let newFile = montaItemArquivoPreview(response.data.file, chave_id, value, origin)
          commit('SET_SUBST_FILE', {file: newFile, hash: file.hash})
          resolve()
        } else {
          file.nome = nameBkp.toUpperCase()
          let error = response.data.erro;
          commit('SET_ERROS', {erros: error})
          reject(error);
        }
      })
      .catch(error => {
        let erro = 'Um erro inesperado ocorreu ao tentar alterar o arquivo';
        commit('SET_ERROS', {erros: erro})
        file.nome = nomeFile_bkp.toUpperCase()
        console.log(error);
        reject(erro)
      })
      .finally(
        file.textLoading = null
      )

      resolve()


    })
  },

  DELETE_FILE: async({commit}, {file, url, chave_id, value}) => {
    return new Promise(async (resolve, reject) => {

      if (!file.id) {
        commit('DELETE_FILE_ARRAY', file.hash)
        resolve()
      }

      let esperar = false
      for (let i = 0; i < 5000; i++) {
        let tst_files = state.files
        esperar = manyFilesDeleting(tst_files)
        if (!esperar) break
        await sleep(4000)
      }

      file.isDeleting = true

      let files = []
      files.push({ id: file.id, file: `${file.nome}.${file.ext}` || '', [chave_id]: value })

      await FileService.deleteFile(url, { files, [chave_id]: value })
      .then(response => {
        if (response.data.status) {
          commit('DELETE_FILE_ARRAY', file.hash)
          resolve()
        } else {
          let erro = 'Um erro inesperado ocorreu ao tentar excluir arquivos selecionados';
          commit('SET_ERROS', {erros: erro})
          reject()
        }
      })
      .catch(error => {
        let erro = 'Um erro inesperado ocorreu ao tentar excluir arquivos selecionados';
        commit('SET_ERROS', {erros: erro})
        console.log(error);
        reject()
      })
    })
  },

  HANDLE_FILES: ({state, commit}, {file, chave_id, value, origin}) => {
    return new Promise(async (resolve, reject) => {
      if (state.files.length) {
        for( let j = 0; j < state.files.length; j++ ){
          if (file.name === state.files[j].name || file.name === state.files[j].nm_fileorig) {
            reject(`Arquivo ${file.name} já inserido`)
          }
        }
      }

      try {
        let response = await utilsLocal.generateFileToUpload(file)
        response[chave_id] = value
        response.origin = origin
        response.hash = genIdTemp()
        commit('SET_FILE_ARRAY', {file: response})
        resolve(response)
      } catch(error) {
        commit('SET_ERROS', { erros: `Erro ao incluir arquivo ${file.name}`})
        reject(error)
      }

    })
  },

  DOWNLOAD_FILE: (commit, {file, url}) => {
    return new Promise((resolve, reject) => {

      file.loading = true
      let payload = {file: file.path_lower}
      utilsLocal.geraUrlToDownloadFile(url, payload)
      .then((response) => {
        if (response.data.status) {
          if (!response.data.url || !response.data.url.link) {
            let error = "Erro ao tentar efetuar download. Impossível recuperar URL do arquivo."
            reject(error)
            return
          }
          let url = response.data.url.link
          var text = `${file.nome}.${file.ext}`
          //criando um elemento invisível
          var link = document.createElement('a');
          link.href = url;
          link.download = url.split("/").pop();
          link.dispatchEvent(new MouseEvent('click'));
          resolve()
          return

        } else {
            let error = "Servidor retornou status=false para download do arquivo."
            reject(error)
        }
      })
      .catch((e) => {
        console.log('Catch downloadURL', e)
        let error = "Erro ao efetuar download do arquivo"
        reject(error)
      })
      .finally(() => file.loading = false)

    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/views/OrquestraFiles/_store/index.js